import { render, staticRenderFns } from "./Modelmaking.vue?vue&type=template&id=56f24d79&scoped=true"
import script from "./Modelmaking.vue?vue&type=script&lang=js"
export * from "./Modelmaking.vue?vue&type=script&lang=js"
import style0 from "./Modelmaking.vue?vue&type=style&index=0&id=56f24d79&prod&scoped=true&lang=css"
import style1 from "./Modelmaking.vue?vue&type=style&index=1&id=56f24d79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f24d79",
  null
  
)

export default component.exports